import endpoints from "config/endpoints";
import { useCallback } from "react";
import useAxiosRequest from "./common/useAxiosRequest";

const useProposta = () => {
  const { data, loading, error, run } = useAxiosRequest({ globalError: false });

  const salvarProposta = useCallback(
    (numeroCotacao) => {
      return run({
        url: endpoints.proposta(),
        method: "POST",
        data: {
          identificacao: {
            codigoCotacao: numeroCotacao,
          },
          cobranca: {
            tpCaptura: "GATEWAY",
            confGateway: {
              urlRetorno: `${window.location.origin}/unico/retorno-pagamento`,
              versao: "v1",
            },
          },
        },
        headers: {
          "X-Remetente": "LOJA",
          "X-Evento-Versao": "2.0",
        },
      });
    },
    [run]
  );

  return { salvarProposta, data, loading, error };
};

export default useProposta;
